var _rect, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.03125,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_36108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0328 8.18188C14.8266 8.18204 14.6264 8.11194 14.4653 7.98313C13.7327 7.39644 13.1243 6.66972 12.6755 5.84539C12.2268 5.02106 11.9467 4.11561 11.8516 3.18187C11.8516 2.33799 12.1868 1.52867 12.7835 0.93195C13.3802 0.335232 14.1896 0 15.0334 0C15.8773 0 16.6866 0.335232 17.2834 0.93195C17.8801 1.52867 18.2153 2.33799 18.2153 3.18187C18.1202 4.11561 17.8401 5.02106 17.3913 5.84539C16.9426 6.66972 16.3342 7.39644 15.6016 7.98313C15.4405 8.11194 15.2403 8.18204 15.0341 8.18188H15.0328ZM15.0328 1.81813C14.6712 1.81846 14.3245 1.96224 14.0689 2.21792C13.8132 2.4736 13.6694 2.82029 13.6691 3.18187C13.7703 4.2591 14.2541 5.2644 15.0328 6.01563C15.8117 5.26408 16.2956 4.25829 16.3966 3.18063C16.3962 2.81904 16.2524 2.47235 15.9968 2.21667C15.7411 1.96099 15.3944 1.81721 15.0328 1.81688V1.81813Z",
    fill: "#9C4900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03281 20.0022C4.82656 20.0024 4.6264 19.9323 4.46531 19.8034C3.73271 19.2167 3.12429 18.49 2.67553 17.6657C2.22677 16.8414 1.94667 15.9359 1.85156 15.0022C1.85156 14.1583 2.18679 13.349 2.78351 12.7523C3.38023 12.1555 4.18955 11.8203 5.03344 11.8203C5.87732 11.8203 6.68665 12.1555 7.28336 12.7523C7.88008 13.349 8.21531 14.1583 8.21531 15.0022C8.12021 15.9359 7.84011 16.8414 7.39135 17.6657C6.94259 18.49 6.33416 19.2167 5.60156 19.8034C5.44048 19.9323 5.24032 20.0024 5.03406 20.0022H5.03281ZM5.03281 13.6384C4.67123 13.6388 4.32454 13.7826 4.06886 14.0382C3.81318 14.2939 3.66939 14.6406 3.66906 15.0022C3.7686 16.0821 4.25254 17.0903 5.03281 17.8434C5.81175 17.0919 6.29558 16.0861 6.39656 15.0084C6.39623 14.6469 6.25244 14.3002 5.99676 14.0445C5.74108 13.7888 5.3944 13.645 5.03281 13.6447V13.6384Z",
    fill: "#9C4900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1229 17.2716H10.0316C9.79043 17.2716 9.55913 17.1758 9.38859 17.0052C9.21805 16.8347 9.12224 16.6034 9.12224 16.3622C9.12224 16.121 9.21805 15.8897 9.38859 15.7192C9.55913 15.5486 9.79043 15.4528 10.0316 15.4528H14.1229C14.7256 15.4528 15.3036 15.2134 15.7298 14.7872C16.1559 14.361 16.3954 13.783 16.3954 13.1803C16.3954 12.5776 16.1559 11.9996 15.7298 11.5734C15.3036 11.1472 14.7256 10.9078 14.1229 10.9078H5.94162C4.8691 10.8891 3.84684 10.4498 3.095 9.68474C2.34316 8.91964 1.92187 7.88987 1.92188 6.81719C1.92187 5.74451 2.34316 4.71473 3.095 3.94963C3.84684 3.18453 4.8691 2.74531 5.94162 2.72656H9.57787C9.81905 2.72656 10.0503 2.82237 10.2209 2.99291C10.3914 3.16345 10.4872 3.39476 10.4872 3.63594C10.4872 3.87712 10.3914 4.10842 10.2209 4.27896C10.0503 4.4495 9.81905 4.54531 9.57787 4.54531H5.94162C5.33891 4.54531 4.76089 4.78474 4.33471 5.21091C3.90854 5.63709 3.66912 6.21511 3.66912 6.81781C3.66912 7.42052 3.90854 7.99854 4.33471 8.42471C4.76089 8.85089 5.33891 9.09031 5.94162 9.09031H14.1229C15.1954 9.10906 16.2176 9.54828 16.9695 10.3134C17.7213 11.0785 18.1426 12.1083 18.1426 13.1809C18.1426 14.2536 17.7213 15.2834 16.9695 16.0485C16.2176 16.8136 15.1954 17.2528 14.1229 17.2716Z",
    fill: "#9C4900"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_36108)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.03125,
    width: 20,
    height: 20,
    fill: "#F6A300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.1ac84583bf1a3a064ebc5c4f47375c16.svg";
export { ForwardRef as ReactComponent };